import React, { useState } from "react";
import styles from './AdminLayout.scss';
import AdminFooter from "./Footer";
import AdminSidebar from "./Sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import ApiService from "../../Core/Service/ApiService";
import AdminHeader from "./header";
import CmsContext, { CmsProvider } from "../../Context/CmsContext";
import { useContext } from "react";
import { useEffect } from "react";


const AdminLayout = React.memo((props) => {
    const navigate = useNavigate();
    const cmsContext = useContext(CmsContext);

    useEffect(() => {
        if(cmsContext.currSubMenu?.url) {
            navigate(cmsContext.currSubMenu.url);
        }
    }, [])

    ApiService.setNavigate(navigate);

    return (
    <section className={`admin-container`}>
        <AdminHeader />
        <main>
            <AdminSidebar />
            <div className="p-2 main-container h-100">
                <Outlet/>
            </div>
        </main>
        <AdminFooter />
    </section>
    )
});

export default AdminLayout;